import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';
import {IAgriAlertTranslateModel, TemplateEnumType} from '@/util/Request/agrialert/responseType';
import {
    getTemplateDetailResModel,
    getSubscriptionDetailResModel,
    IgetAllBannersResModel,
    IAgronomicRedommedationModel,
    IHistoricalChartsModel,
    IForecastChartOrTableModel
} from '@/util/Request/agrialert/requestType';
import { IFileContent } from '@/util/Request/requestType';

interface IAgriAlertPreviewModel{
    templateName?: string;
    templateDate?: string;
    templateBannerList?: string[]
    templateDescription?: string;
    templateLocationName?: string;
    templateLat?: number;
    templateLng?: number;
    // for historical and forecast
    isShowHistoricalChart?: boolean;
    isShowForecastChart?: boolean;
    isShowForecastTable?: boolean;
    isShowForecastTableHourly?: boolean;
    historicalAggregation?: string;
    historicalDays?: number;
    historicalVariables?: string[];
    forecastVariables?: string[];
    forecastTableDailyVariables?: string[];
    forecastTableHourlyVariables?: string[];
    forecastChartVariables?: string[];
    // for spray
    isShowSpray?: boolean;
    sprayType?: string[];
    // language
    languageCode?: string;
    reportUnit?: string;
    editableFooter?:string;
    // for agronomic
    isShowAgronomic?: boolean;
    agronomic?: IAgronomicRedommedationModel[]
    // for historical charts
    historicalCharts?: IHistoricalChartsModel[]
    // for Forecast charts and tables
    forecastCharts?: IForecastChartOrTableModel[]
    forecastTables?: IForecastChartOrTableModel[]
}

interface IAgrialertTemplateModel {
    templateType: TemplateEnumType,
    previewDetails?: IAgriAlertPreviewModel,
    tempDetails:getTemplateDetailResModel,
    subscriptionDetails:getSubscriptionDetailResModel,
    allBananer?: IgetAllBannersResModel[],
    successOpen?: boolean,
    tempOrSubName?:string,
    fileContent?:IFileContent[],
    translateData?: IAgriAlertTranslateModel[],
    tab?:number,
    // current user info
    currentRoleId?: number
    currnetUserId?: string
}

// const token = localStorage.getItem('accessToken');
const initialState: IAgrialertTemplateModel = {
    templateType: TemplateEnumType.LISTTEMPLATE,
    previewDetails: {
        templateName: 'Agri-Alert-Template-2024-08-13',
        templateDate: 'June 15 2022',
        templateBannerList: null,
        templateDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                                labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
                                nisi ut aliquip ex ea commodo consequat.`,
        templateLocationName: 'London',
        templateLat: 51.507351,
        templateLng: 0.1278,
        // for historical and forecast
        isShowHistoricalChart: true,
        isShowForecastChart: true,
        isShowForecastTable: true,
        isShowForecastTableHourly: true,
        historicalAggregation: 'daily',
        historicalDays: 7,
        historicalVariables: ['precipitation','soil_temperature'],
        forecastVariables: ['precipitation','soil_temperature'],
        forecastTableDailyVariables: ['precipitation','soil_temperature'],
        forecastTableHourlyVariables: ['precipitation','soil_temperature'],
        forecastChartVariables: ['precipitation','soil_temperature'],
        // for spray
        isShowSpray: true,
        sprayType: ['sw_aerialspraygeneric'],
        languageCode: 'en',
        editableFooter:''
    },
    tempDetails:{
        templateId: 1,
        templateName: 'Test2024080702',
        'templateCreateTime': '2024/08/27 07:18:55',
        locationList: [
            {
                locationId: 1,
                templateId: 1,
                locationName: 'Beijing',
                lat: 39.9075,
                lng: 116.39723,
                toUserEmail: 'aaron.li@syngenta.com;kaimin.tan@syngenta.com',
                sortNumber: 0
            }
        ],
        templateIsActive: true,
        timezoneId: 59,
        timezoneOffset: 8,
        startDate: '2024-08-16',
        endDate: '2024-08-30',
        isShowHistoricalChart: true,
        isShowForecastChart: true,
        isShowForecastTable: true,
        isShowForecastTableHourly: true,
        isShowSpray: true,
        isShowAgronomic: true,
        agronomicRecommendations: [],
        reportHour: 10,
        reportAggregation: 'Daily',
        reportWeek: 'string',
        reportLanguageCode: 'en',
        reportSubject: 'Test Subject',
        reportMessage: 'Test Message',
        reportBanner: 'Testbanner.jpg',
        historicalAggregation: 'Testbanner.jpg',
        historicalDays: 7,
        historicalVariables: 'TestHistVariable',
        forecastVariables: 'TestForecastVariable',
        forecastTableDailyVariables: 'TestForecastVariable',
        forecastTableHourlyVariables: 'TestForecastVariable',
        forecastChartVariables: 'TestForecastVariable',
        sprayType: 'sw_groundspraygeneric',
        editableFooter:'',
    },
    subscriptionDetails:{
        subscriptionId: 1,
        templateCreateTime: '2024/08/27 07:18:55',
        locationList: [
            {
                locationId: 1,
                templateId: 1,
                locationName: 'Beijing',
                lat: 39.9075,
                lng: 116.39723,
                toUserEmail: 'aaron.li@syngenta.com;kaimin.tan@syngenta.com',
                sortNumber: 0
            },
            {
                locationId: 5,
                templateId: 1,
                locationName: 'Hangzhou',
                lat: 39.9075,
                lng: 116.39723,
                toUserEmail: 'aaron.li@syngenta.com',
                sortNumber: 1
            },],
        subscriptionName: 'string',
        timezoneId: null,
        timezoneOffset: 4,
        startDate: '',
        endDate: '',
        reportHour: 12,
        reportAggregation: '',
        reportWeek: '',
        reportLanguageCode: '',
        subscriptionIsActive: true,
        isShowHistoricalChart: false,
        isShowForecastChart: false,
        isShowForecastTable: false,
        isShowForecastTableHourly: false,
        isShowSpray: false,
        isShowAgronomic: false,
        agronomicRecommendations: [],
        reportSubject: '',
        reportMessage: '',
        reportBanner: null,
        historicalAggregation: null,
        historicalDays: null,
        historicalVariables: null,
        forecastVariables: null,
        forecastTableDailyVariables: null,
        forecastTableHourlyVariables: null,
        forecastChartVariables: null,
        sprayType: null,
        editableFooter:'',
    },
    allBananer: [],
    successOpen: false,
    tempOrSubName:'',
    fileContent:[],
    translateData: [],
    tab:null,
    currentRoleId: null,
    currnetUserId: null
};


export const agrialertTemplateSlice = createSlice({
    name: 'agrialerttemplate',
    initialState,
    reducers: {
        updateTemplateType: (state, action: PayloadAction<TemplateEnumType>) => {
            return {
                ...state,
                templateType: action.payload
            };
        },
        updatePreviewDetails: (state, action: PayloadAction<IAgriAlertPreviewModel>) => {
            return {
                ...state,
                previewDetails: action.payload
            };
        },
        updateTempDetails: (state, action: PayloadAction<getTemplateDetailResModel>) => {
            return {
                ...state,
                tempDetails: action.payload
            };
        },
        updateSubscriptionDetails: (state, action: PayloadAction<getSubscriptionDetailResModel>) => {
            return {
                ...state,
                subscriptionDetails: action.payload
            };
        },
        updateAllBanner: (state, action: PayloadAction<IgetAllBannersResModel[]>) => {
            return {
                ...state,
                allBananer: action.payload
            };
        },
        updateSuccessOpen: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                successOpen: action.payload
            };
        },
        updateTempOrSubName: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                tempOrSubName: action.payload
            };
        },
        updateFileContent:(state, action: PayloadAction<IFileContent[]>) => {
            return {
                ...state,
                fileContent: action.payload
            };
        },
        updateTranslateData:(state, action: PayloadAction<IAgriAlertTranslateModel[]>) => {
            return {
                ...state,
                translateData: action.payload
            };
        },
        updateTab:(state, action: PayloadAction<number>) => {
            return {
                ...state,
                tab: action.payload
            };
        },
        updateCurrentRoleId:(state, action: PayloadAction<number>) => {
            return {
                ...state,
                currentRoleId: action.payload
            };
        },
        updateCurrentUserId:(state, action: PayloadAction<string>) => {
            return {
                ...state,
                currnetUserId: action.payload
            };
        },
    }
});

export type {
    IAgrialertTemplateModel
};

export const {
    updateTemplateType,
    updateTempDetails,
    updateSubscriptionDetails,
    updatePreviewDetails,
    updateAllBanner,
    updateSuccessOpen,
    updateTempOrSubName,
    updateFileContent,
    updateTranslateData,
    updateTab,
    updateCurrentRoleId,
    updateCurrentUserId
} = agrialertTemplateSlice.actions;

export const selectAgrialertTemplate = (state: RootState) => state.agrialertTemplate;

export default agrialertTemplateSlice.reducer;